$(document).foundation()
$('#menu-toggle').on('click', function() {
  $('.mobile-menu').slideToggle();
});

$('#designers-toggle').on('click', function() {
  $('.designer-dropdown').slideToggle();
  if($('.clothing-dropdown').is(':visible')) {
    $('.clothing-dropdown').slideToggle();
  }
});

$('#clothing-toggle').on('click', function() {
  $('.clothing-dropdown').slideToggle();
  if($('.designer-dropdown').is(':visible')) {
    $('.designer-dropdown').slideToggle();
  }
});

$('.clothing-dropdown').on('mouseleave', function() {
  if($('.clothing-dropdown').is(':visible')) {
    $('.clothing-dropdown').slideToggle();
  }
});

$('.designer-dropdown').on('mouseleave', function() {
  if($('.designer-dropdown').is(':visible')) {
    $('.designer-dropdown').slideToggle();
  }
});

$('#search-toggle').on('mouseenter', function() {
  $('.search-bar').addClass('search-bar-expand');
});

$('.search-bar').on('mouseleave', function() {
  $('.search-bar').removeClass('search-bar-expand');
});

$('#cart-toggle').on('click', function() {
  $('.cart-popup').show(400);
  $('.cart-popup .content').removeClass('cart-animate-out');
  $('.cart-popup .content').addClass('cart-animate');
});

$('.cart-popup .overlay').on('click', function() {
  $('.cart-popup').hide(600);
  $('.cart-popup .content').removeClass('cart-animate');
  $('.cart-popup .content').addClass('cart-animate-out');
});

$('#continue-shopping').on('click', function() {
  $('.cart-popup .content').removeClass('cart-animate');
  $('.cart-popup .content').addClass('cart-animate-out');
  $('.cart-popup').hide(600);
});

$('#hero').slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 6000
});

$('#designer-carousel').slick({
  prevArrow: $('.designer-carousel .prev'),
  nextArrow: $('.designer-carousel .next')
});

$('#designer-big-carousel').slick();

$('#three-row').on('click', function() {
  $('.four-row').fadeOut(400);
  $('.three-row').delay(400).fadeIn(400);
  $('#three-row').addClass('active');
  $('#four-row').removeClass('active');
});

$('#four-row').on('click', function() {
  $('.three-row').fadeOut(400);
  $('.four-row').delay(400).fadeIn(400);
  $('#four-row').addClass('active');
  $('#three-row').removeClass('active');
});

$('#filter-toggle').on('click', function() {
  $('.category .filters').slideToggle(400);
});

$('#close-filters').on('click', function() {
  $('.category .filters').slideToggle(400);
});

$('#apply-filters').on('click', function() {
  $('.category .filters').slideToggle(400);
});

$('.size-toggle').on('click', function() {
  $('.size-guide').slideToggle(400);
});

$('#close-size').on('click', function() {
  $('.size-guide').slideToggle(400);
});

/*$('#slideshow-wrapper').height($('.product-details').height()+160);
$('#product-slideshow').height($('.product-details').height()+160);
$('#product-slideshow img').height($('.product-details').height()+160);*/

/* $('#product-slideshow').slick({
  autoplay: true,
  autoplaySpeed: 10000,
  arrows: true,
  draggable: false,
  dots: true,
  appendDots: $('#dots-wrapper'),
  appendArrows: $('#dots-wrapper'),
  customPaging : function(slider, i) {
    //var thumb = $(slider.$slides[i]).attr('src');
    var thumb = slider.$slides.eq(i).find('img').attr('src');
    return '<a><img src="'+thumb+'" class="slide-thumb"></a>';
  },
}); */

$('#product-slideshow').slick({
  autoplay: true,
  autoplaySpeed: 10000,
  arrows: false,
  draggable: true,
  fade: true,
});


$('#product-slideshow-small').slick({
  autoplay: true,
  autoplaySpeed: 10000,
  arrows: false
});

$('#related-items').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: $('#related-prev'),
  nextArrow: $('#related-next'),
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('#general-enquiries').on('click', function() {
  $('.general-ans').show();
  $('.general-ans ~ ul').hide();
});

$('#privacy').on('click', function() {
  $('.privacy-ans').show();
  $('.privacy-ans ~ ul').hide();
  $('.general-ans').hide();
});

$('#tnc').on('click', function() {
  $('.tnc-ans').show();
  $('.general-ans').hide();
  $('.privacy-ans').hide();
});